import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
    IonRadioGroup,
    IonRadio,
    IonItem,
    IonLabel,
    IonList,
} from "@ionic/react";


// Union type for all question types
type Question =
    | MultipleChoiceQuestion
    | FillInTheBlankQuestion
    | TrueFalseQuestion

// Question Type Definitions
interface BaseQuestion {
    question: string;
}

interface MultipleChoiceQuestion extends BaseQuestion {
    type: "multiple-choice";
    options: string[];
    answer: string;
}

interface FillInTheBlankQuestion extends BaseQuestion {
    type: "fill-in-the-blank";
    options: string[];
    answer: string;
}

interface TrueFalseQuestion extends BaseQuestion {
    type: "true-false";
    answer: string;
}




const Money: React.FC = () => {
    const [questions, setQuestions] = useState<Question[]>([]);
    const [currentQuestion, setCurrentQuestion] = useState<Question | null>(null);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [matchOption, setMatchOption] = useState<string[] | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const loadRandomSyllabusQuestions = async () => {

        try {
            let data: Question[] = [];
            if (process.env.REACT_APP_DEVELOPMENT !== "WEB") {
                const response = await fetch(
                    process.env.REACT_APP_API_URL + "ClassThreeMathematics/Money.json"
                );
                data = await response.json();
            } else {
                const module = await import(
                    `../../../datas/ClassThreeMathematics/Money.json`
                );
                data = module.default as Question[];
            }

            setQuestions(data);
            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
            setCurrentQuestion(shuffledQuestions[currentIndex]);
        } catch (err) {
            console.error("Failed to load questions:", err);
        }
    };

    const handleAnswerSubmit = (option: string) => {
        setSelectedOption(option);
        let isCorrect;
        if (!currentQuestion) return;

        let correctAnswer: string | boolean = "";
        if (
            currentQuestion.type === "multiple-choice" ||
            currentQuestion.type === "fill-in-the-blank"
        ) {
            correctAnswer = currentQuestion.answer;

            isCorrect = option.trim().toLowerCase() === correctAnswer.trim().toLowerCase()

        } else if (currentQuestion.type === "true-false") {
            correctAnswer = currentQuestion.answer;
            isCorrect = option.trim().toLowerCase() === String(correctAnswer).toLowerCase()
        }

        if (isCorrect == true) {
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                    setShowImage(false);
                    setSelectedOption(null);
                    setCurrentQuestion(questions[nextIndex]);
                }
                else {
                    setCurrentIndex(0);
                    loadRandomSyllabusQuestions();
                }
            }, 5000);
        }
    };

    // Function to shuffle an array
    function shuffleArray(array: any[]) {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    }

    useEffect(() => {
        loadRandomSyllabusQuestions();

        document.title =
            "Mamas Guidance - Class Three - Mathematics";
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content="Prepare for Class 1 IGKO Olympiad with Mama's Guidance. Access syllabus details, sample questions, tips, and practice worksheets to boost your child's performance." />
            </Helmet>
            {!showImage ? (
                <div className="contentPart showCenter additionWord">
                    {currentQuestion ? (
                        <>
                            <h3 className="mb-3">{currentQuestion.question}</h3>
                            {(currentQuestion.type === "multiple-choice" ||
                                currentQuestion.type === "fill-in-the-blank") && (
                                    <IonRadioGroup
                                        onIonChange={(e) => handleAnswerSubmit(e.detail.value)}
                                    >
                                        <IonList>
                                            {(currentQuestion.options || []).map((option, index) => (
                                                <IonItem
                                                    className={`grid-item ${selectedOption === option
                                                        ? option.toLowerCase() === currentQuestion.answer.toLowerCase()
                                                            ? "correct"
                                                            : "errorItems"
                                                        : ""
                                                        }`}
                                                    key={index}
                                                >
                                                    <IonRadio slot="start" value={option} />
                                                    <IonLabel>{option}</IonLabel>
                                                </IonItem>
                                            ))}
                                        </IonList>
                                    </IonRadioGroup>
                                )}
                            {currentQuestion.type === "true-false" && (
                                <IonRadioGroup
                                    onIonChange={(e) => handleAnswerSubmit(e.detail.value)}
                                >
                                    <IonList>
                                        {["true", "false"].map((option, index) => (
                                            <IonItem key={index} className={`${selectedOption === option
                                                ? option.toLowerCase() === currentQuestion.answer
                                                    ? "correct"
                                                    : "errorItems"
                                                : ""
                                                }`}>
                                                <IonRadio slot="start" value={option} />
                                                <IonLabel>{option.toUpperCase()}</IonLabel>
                                            </IonItem>
                                        ))}
                                    </IonList>
                                </IonRadioGroup>
                            )}
                        </>
                    ) : (
                        <p>Loading question...</p>
                    )}
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                        alt="Well done"
                    />
                </div>
            )}
        </>
    );
};

export default Money;
